import { stats } from '@fiverr-private/obs';
import { BriefClassificationResponse, LeafClassification } from '../../api';
import { METRICS_PREFIX } from '../../constants';
import { getLeafId } from '../../utils';
import { useBriefCreationContext } from '../../context/BriefCreationContext';
import { logger } from '../../utils/logger';
import { useExtractAdditionalData } from './useExtractAdditionalData';

export const useHandleDisambiguation = () => {
    const { contextId, briefClassification } = useBriefCreationContext();
    const { extractAdditionalData } = useExtractAdditionalData();
    const handleDisambiguationStep = async ({
        leafCategoryId,
        userInput,
        abortController,
    }): Promise<
        | {
              selectedLeafClassification: LeafClassification;
              extractedData?: BriefClassificationResponse;
          }
        | undefined
    > => {
        if (!briefClassification) {
            logger.error(new Error('Disambiguation without classification'), { userInput });
            stats.count(`${METRICS_PREFIX}.disambiguation_without_classification`, `error`);
            return;
        }

        const matchFunction = (leaf: LeafClassification) => getLeafId(leaf) === leafCategoryId;

        const leafClassification =
            briefClassification.leaf_classification.find(matchFunction) || briefClassification.leaf_classification[0];
        const extractedData = await extractAdditionalData({
            leafClassification,
            contextId,
            userInput,
            abortController,
            requestType: 'disambiguation_extract_additional_data',
        });

        return {
            selectedLeafClassification: leafClassification,
            extractedData,
        };
    };

    return {
        handleDisambiguationStep,
    };
};
